var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("has-" + (this.memberCount)),attrs:{"id":"comp-members"}},_vm._l((_vm.members),function(user){return _c('div',{key:user.userSeqId,staticClass:"member-container"},[_c('comp-profile',{attrs:{"userInitial":user.nickname.split('')[0],"profileImage":user.matchUserPhoto}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c98849a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompMembers.vue
// module id = null
// module chunks = 